import React, { useEffect, useState } from 'react';
import Footer from '../../shared/footer/Footer';
import LoginModal from '../../main/loginModal/LoginModal';
import Head from '../../Global/Head';
import Header from '../../Global/Header';
import img from '../../../images/blog2.jpg';
import { AiOutlineCalendar, AiOutlineShareAlt } from 'react-icons/ai';
import { HiOutlineLocationMarker } from 'react-icons/hi';
import { BsBookmark } from 'react-icons/bs';

export default function Blog2() {
  const accessToken = localStorage.getItem("@user");
  const [isVisible, setIsVisible] = useState(!!accessToken ? false : true);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const increment = 1300 / steps;

    if (isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - increment;
        });
      }, intervalTime);
    }

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="min-h-screen ">
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <Head />

      <Header />
      <div className="max-w-7xl mx-auto p-6">
        <h1 className="text-4xl font-bold mt-4">The Cost of Loneliness: Why Connection Matters More Than Ever</h1>
        <div className="mt-4 flex items-start justify-between">
          <div className="flex items-center gap-4 text-sm text-gray-600">
            
            <div className="flex items-center gap-2">
              <span className="inline-block bg-black text-white px-2 py-0.5 rounded">HighTable</span>
            </div>
          </div>
         
        </div>

        <div className="mt-6 rounded-lg overflow-hidden">
          <img src={img} alt="Loneliness" className="w-full h-64 sm:h-96 object-cover" />
        </div>

        <div className="prose max-w-none mt-6">
          <p>
            Loneliness isn’t just a feeling—it’s a public health issue. Recent research shows that
            chronic loneliness can be as damaging as smoking 15 cigarettes a day. And yet, in an
            era of unprecedented digital “connectivity,” millions still feel isolated, invisible,
            or disconnected from the communities around them.
          </p>

          <h2>Loneliness isn’t just emotional</h2>
          <p>
            We often reduce loneliness to sadness or missing companionship. The reality is deeper:
            chronic loneliness affects mental, emotional, and physical health. It raises the risk
            of anxiety, depression, sleep disorders, heart disease, and even early mortality.
          </p>
          <p>
            Loneliness also undermines productivity and creativity. People who feel isolated find
            it harder to focus, take risks, or innovate. Over time, this erodes not only individual
            well-being but the collective potential of workplaces and communities.
          </p>

          <h2>The social paradox</h2>
          <p>
            We live in an age of hyper-connectivity—social media, messaging apps, and networks
            promise to keep us close. For many, though, those connections remain superficial:
            counting likes instead of creating meaningful interactions. You can be “connected” to
            thousands online and still feel completely alone.
          </p>

          <h2>Why we need to care</h2>
          <p>
            Loneliness carries social and economic costs. It strains healthcare systems, reduces
            workplace productivity, and increases reliance on digital escapes that often worsen
            isolation. Because this crisis is often invisible, it receives less attention than it
            deserves.
          </p>
          <p>
            That’s why building spaces that foster genuine human connection is essential—not a
            luxury. Community, meaningful friendships, and safe places to be yourself are
            foundations for thriving societies.
          </p>

          <h2>Hightable’s approach</h2>
          <p>
            At Hightable, our mission is simple: turn digital connections into genuine belonging.
            Every feature, interaction, and design choice focuses on helping people find their
            tribe—through authentic, serendipitous connections rather than forced networking.
          </p>
          <p>
            Reducing loneliness unlocks happier individuals and healthier, more vibrant
            communities. It helps reclaim what busy cities and digital spaces often take away:
            the simple joy of feeling truly seen.
          </p>

          <h2>Conclusion</h2>
          <p>
            Loneliness has a cost—and it has solutions. Connection isn’t optional; it’s essential.
            By prioritizing belonging over superficial networking, we can transform lives and build
            stronger communities. That’s what we’re building at Hightable: a platform where people
            don’t just meet—they truly belong.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
